<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    @if (isDirectOwnerDataPresent) {
<div class="section-block">
      <div class="text-center section-header" (click)="DirectOwnerCollapsed=!DirectOwnerCollapsed">
        <a href="javascript:void(0)" style="color:#fff;">Current Direct Owner Information</a>
      </div>
      <br>
      @if (DirectOwnerCollapsed) {
<div>
        <table class="table table-bordered custom-table">
          <thead>
            <tr>
              <th rowspan="2">Current Direct Owner LEID</th>
              <th rowspan="2">Name and address</th>
              <th rowspan="2">Country under whose laws organized</th>
              <th rowspan="2">U.S. identifying number, if any</th>
              <th rowspan="2">Functional currency</th>
              <th rowspan="2">Action</th>
            </tr>
          </thead>
          <tbody>
            @for (item of directOwnerObj; track $index) {
<tr>
              <td>{{ item['8858_NA_DIRECT_OWNER_LEID'] }}</td>
              <td>
                <div class="addr-line">{{ item['8858_NA_DIRECT_OWNER_NAME_1'] }} {{ item['8858_NA_DIRECT_OWNER_NAME_2'] }}</div>
                <div class="addr-line">{{ item['8858_NA_DIRECT_OWNER_US_COUNTRY'] === 'US' ? item['8858_NA_DIRECT_OWNER_US_ADDR_1'] : item['8858_NA_DIRECT_OWNER_F_ADDR_1'] }}</div>
                <div class="addr-line">{{ item['8858_NA_DIRECT_OWNER_US_COUNTRY'] === 'US' ? item['8858_NA_DIRECT_OWNER_US_ADDR_2'] : item['8858_NA_DIRECT_OWNER_F_ADDR_2'] }} {{ item['8858_NA_DIRECT_OWNER_US_COUNTRY'] === 'US' ? item['8858_NA_DIRECT_OWNER_US_CITY'] : item['8858_NA_DIRECT_OWNER_F_CITY'] }}</div>
                <div class="addr-line">{{ item['8858_NA_DIRECT_OWNER_US_STATE'] || item['8858_NA_DIRECT_OWNER_F_STATE'] }}</div>
                <div class="addr-line">{{ item['8858_NA_DIRECT_OWNER_US_COUNTRY'] === 'US' ? item['8858_NA_DIRECT_OWNER_US_ZIP'] : item['8858_NA_DIRECT_OWNER_F_ZIP'] }}</div>
                <div class="addr-line">{{ item['8858_NA_DIRECT_OWNER_US_COUNTRY'] === 'US' ? '' : item['8858_NA_DIRECT_OWNER_F_COUNTRY'] }}</div>
              </td>
              <td>{{ item['8858_NA_DIRECT_OWNER_COUNTRY_LAWS'] }}</td>
              <td>{{ item['8858_NA_DIRECT_OWNER_EIN'] }}</td>
              <td>{{ item['8858_NA_DIRECT_OWNER_FUNC_CURRENCY'] }}</td>
              <td>
                <button class="delete-button" type="button" (click)="deleteSchedule(item)">Delete</button>
              </td>
            </tr>
}
          </tbody>
        </table>
      </div>
}
    </div>
}

    <div class="form-group form-group-row">
      <label class="control-label">Add new Direct Owner</label>
      @if ((assignOwnerList?.values?.length ?? 0) > 0) {
<div class="select-wrap">
        <gtw-df-select-multiple
          [filter]="assignOwnerList"
          (filterChange)="onAssignOwnerFilterChange()">
        </gtw-df-select-multiple>
      </div>
}
    </div>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
